export class AdminDisableUserPayload {}